import { ReduxDispatch } from "models/ReduxProps";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import ActionUtility from "../../utilities/ActionUtility";
import NuovoNotaFormModel from "./models/NuovoNotaFormModel";
import NotaEstimateModel from "./models/NotaEstimateModel";
import NotaEffect, { IAddNoteRequest, IGetNoteTopicsRequest } from "./NotaEffect";
import NoteTopicsModel from "./models/NoteTopicsModel";
import NotaOrderModel from "./models/NotaOrderModel";
import NotaAsRead from "./models/NotaAsRead";

type ActionUnion =
    | undefined
    | HttpErrorResponseModel
    | NuovoNotaFormModel
    | NotaEstimateModel
    | NoteTopicsModel
    | NotaOrderModel;

export default class NotaAction {
    public static readonly REQUEST_GET_NOTE_PREVENTIVO: string = "NotaAction.REQUEST_GET_NOTE_PREVENTIVO";
    public static readonly REQUEST_GET_NOTE_PREVENTIVO_FINISHED: string =
        "NotaAction.REQUEST_GET_NOTE_PREVENTIVO_FINISHED";

    public static readonly REQUEST_ADD_NOTE: string = "NotaAction.REQUEST_ADD_NOTE";
    public static readonly REQUEST_ADD_NOTE_FINISHED: string = "NotaAction.REQUEST_ADD_NOTE_FINISHED";

    public static readonly REQUEST_GET_NOTE_TOPICS: string = "NotaAction.REQUEST_GET_NOTE_TOPICS";
    public static readonly REQUEST_GET_NOTE_TOPICS_FINISHED: string = "NotaAction.REQUEST_GET_NOTE_TOPICS_FINISHED";

    public static readonly REQUEST_CERCA_PREVENTIVI_FORM: string = "NotaAction.REQUEST_CERCA_PREVENTIVI_FORM";
    public static readonly REQUEST_CERCA_PREVENTIVI_FORM_FINISHED: string =
        "NotaAction.REQUEST_CERCA_PREVENTIVI_FORM_FINISHED";

    public static readonly REQUEST_NOTE_TABLE_FORM: string = "NotaAction.REQUEST_NOTE_TABLE_FORM";

    public static readonly REQUEST_NUOVA_NOTA_FORM_SET: string = "NotaAction.REQUEST_NUOVA_NOTA_FORM_SET";

    public static readonly REQUEST_SET_NOTA_INTERNA: string = "NotaAction.REQUEST_SET_NOTA_INTERNA";

    public static readonly REQUEST_RESET_NUOVA_NOTA: string = "NotaAction.REQUEST_RESET_NUOVA_NOTA";

    public static readonly REQUEST_NOTA_DETAILS: string = "NotaAction.REQUEST_NOTA_DETAILS";

    public static readonly REQUEST_SET_NOTE_AS_READ: string = "NotaAction.REQUEST_SET_NOTE_AS_READ";
    public static readonly REQUEST_SET_NOTE_AS_READ_FINISHED: string = "NotaAction.REQUEST_SET_NOTE_AS_READ_FINISHED";

    public static getEstimateNote(idEstimate: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<NotaEstimateModel>(
                dispatch,
                NotaAction.REQUEST_GET_NOTE_PREVENTIVO,
                NotaEffect.getEstimateNote,
                idEstimate
            );
        };
    }

    public static addNota(request: IAddNoteRequest): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<NotaEstimateModel>(
                dispatch,
                NotaAction.REQUEST_ADD_NOTE,
                NotaEffect.addNota,
                request
            );
        };
    }

    public static getNoteTopics(request: IGetNoteTopicsRequest): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<NoteTopicsModel>(
                dispatch,
                NotaAction.REQUEST_GET_NOTE_TOPICS,
                NotaEffect.getNoteTopics,
                request
            );
        };
    }

    public static setTabellaNoteForm(form: NotaOrderModel): any {
        return ActionUtility.createAction(NotaAction.REQUEST_NOTE_TABLE_FORM, form);
    }

    public static setNuovoNotaForm(form: NuovoNotaFormModel): any {
        return ActionUtility.createAction(NotaAction.REQUEST_NUOVA_NOTA_FORM_SET, form);
    }

    public static setNotaInterna(interna: boolean): any {
        return ActionUtility.createAction(NotaAction.REQUEST_SET_NOTA_INTERNA, interna);
    }

    public static resetNuovoNota(): any {
        return ActionUtility.createAction(NotaAction.REQUEST_RESET_NUOVA_NOTA);
    }

    public static setNotaDetails(nota: NotaEstimateModel): any {
        return ActionUtility.createAction(NotaAction.REQUEST_NOTA_DETAILS, nota);
    }

    public static setNoteAsRead(idEstimate: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<NotaAsRead>(
                dispatch,
                NotaAction.REQUEST_SET_NOTE_AS_READ,
                NotaEffect.setNoteAsRead,
                idEstimate
            );
        };
    }
}
